import { Injectable } from '@angular/core';
import { lastValueFrom, map, Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { WrapperStandardRequest, WrapperStandardResponse } from '../../common/models/wrapper.model';
import { MatSnackBar } from '@angular/material/snack-bar';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json'})
};
@Injectable({
  providedIn: 'root'
})
export class BaseService<T> {


  // public abstract getById(id: number): Observable<T>;
  //public abstract getAll(): Observable<T>;

  constructor(private httpClient: HttpClient,private _snackBar: MatSnackBar) {

  }

  PostAPIWithWrapperAndT(aUrl: string, aRequestData: any): Observable<WrapperStandardResponse<T>> {

    const wrapperStandardRequest: WrapperStandardRequest<T> = new WrapperStandardRequest<T>();

    wrapperStandardRequest.RequestData = aRequestData;

    return this.httpClient.post<WrapperStandardResponse<Array<T>>>(aUrl, wrapperStandardRequest, httpOptions)
      .pipe(map((response: WrapperStandardResponse<T>) => {

        return response;
      }))

  }

  PostAPIWithWrapperAndAny(aUrl: string, aRequestData: any): Observable<WrapperStandardResponse<any>> {

    const wrapperStandardRequest: WrapperStandardRequest<any> = new WrapperStandardRequest<any>();

    wrapperStandardRequest.RequestData = aRequestData;

    return this.httpClient.post<WrapperStandardResponse<any>>(aUrl, wrapperStandardRequest, httpOptions)
      .pipe(map((response: WrapperStandardResponse<any>) => {

        return response;
      }))

  }

  PostAPI(aUrl: string, aRequestData: any, search:string=''): Observable<any> {

   

     let url = aUrl;
    // if(search){
    //   url = `${aUrl}?$filter=${search}`
    // }
    // else{
    //   url = aUrl;
    //   aRequestData.PageSize = 1;
    // }

    return this.httpClient.post(url, aRequestData, { withCredentials: true })
      .pipe(map((response: any) => {

        return response;
      }))
      
  } 

  

  PatchAPI(aUrl: string, aRequestData: any): Observable<any> {

    return this.httpClient.patch(aUrl, aRequestData, { withCredentials: true })
      .pipe(map((response: any) => {
        return response;
      }))

  }
  PostAPIWithOptions(aUrl: string, aRequestData: any, httpOptions:any): Promise<any> {

    return lastValueFrom(this.httpClient.post(aUrl, aRequestData, httpOptions)
      .pipe(map((response: any) => {

        return response;
      })))

  }

  GetAPI(aUrl: string): Observable<any> {

    return this.httpClient.get(aUrl, { withCredentials: true })
      .pipe(map((response: any) => {
        return response;
      }))
      
  }

  showMessage(message: string, action: string) {
    this._snackBar.open(message, action,{duration: 3000});
  }
  
  

}